enum RejectReasonEnum {
    AssetClass = 'ASSET_CLASS',
    Location = 'LOCATION',
    LostToOther = 'LOST_TO_OTHER',
    Lvr = 'LVR',
    Product = 'PRODUCT',
}

export default RejectReasonEnum;
